import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AuthUIService } from 'src/app/services/auth/auth-ui.service';
import { AUTH_UI_SERVICE } from 'src/app/services/auth/auth-ui.service.interface';

import { AuthPageRoutingModule } from './auth-routing.module';
import { MIComponentsModule } from 'src/app/components/components.module';
import { TranslateModule } from '@ngx-translate/core';
import { SwiperModule } from 'swiper/angular';

import { AuthPage } from './auth.page';
import { MIDirectivesModule } from 'src/app/directives/directives.module';
import { AuthWelcomeSmallScreenComponent }
  from 'src/app/modules/auth-components/auth-welcome-small-screen/auth-welcome-small-screen.component';
import { AuthButtonsComponent } from 'src/app/modules/auth-components/auth-buttons/auth-buttons.component';
import { IconComponent } from 'src/app/modules/icon/icon.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AuthPageRoutingModule,
    MIComponentsModule,
    TranslateModule,
    SwiperModule,
    MIDirectivesModule,
    AuthWelcomeSmallScreenComponent,
    AuthButtonsComponent,
    IconComponent
  ],
  providers: [
    { provide: AUTH_UI_SERVICE, useClass: AuthUIService },
  ],
  declarations: [AuthPage]
})
export class AuthPageModule { }
